module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-control",
    class: _vm.formClass
  }, [_c('v-form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [(_vm.value) ? _c('ControlList', {
    attrs: {
      "value": _vm.value,
      "schema": _vm.schemaFields,
      "context": _vm.childContext
    },
    on: {
      "change": _vm.emitChanges
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f24e749"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/forms/FormControl.vue
// module id = 2574
// module chunks = 1